export const getPortalId = state => {
  return state.portalId;
};